import { CandidateData } from '../../../../types/candidates';

const filterBySalaryRange = (
  singleCandidate: CandidateData,
  searchedSalary: number
) => {
  return (
    singleCandidate?.CandidateJobInterest &&
    typeof singleCandidate?.CandidateJobInterest?.SalaryLowerBound ===
      'number' &&
    searchedSalary >= singleCandidate.CandidateJobInterest.SalaryLowerBound
  );
};

export default filterBySalaryRange;
